import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loaderSubject = new BehaviorSubject<boolean>(false);
  
  public readonly isLoading$: Observable<boolean> = this.loaderSubject.asObservable();

  emitIsLoading(isLoading: boolean): void {
    this.loaderSubject.next(isLoading);
  }

  get isLoading(): boolean {
    return this.loaderSubject.value;
  }
}
